export default class Options {

    get appointmentTypeId() {
        return this.options?.AppointmentTypeId || this.options?.appointmentTypeId;
    }

    set appointmentTypeId(value) {
        this.options.AppointmentTypeId = this.options.appointmentTypeId = value;
    }

    get appointmentType() {
        return this.options?.AppointmentType || this.options?.appointmentType;
    }

    set appointmentType(value) {
        this.options.AppointmentType = this.options.appointmentType = value;
    }
    
    get categoryName() {
        return this.options?.CategoryName || this.options?.categoryName;
    }

    set categoryName(value) {
        this.options.CategoryName = this.options.categoryName = value;
    }

    get categoryId() {
        return this.options?.CategoryId || this.options?.categoryId;
    }

    set categoryId(value) {
        this.options.CategoryId = this.options.categoryId = value;
    }

    get locationId() {
        return this.options?.LocationId || this.options?.locationId;
    }

    constructor(options = {}) {
        this.options = options;
    }

    get hasPresetAppointmentType() {
        return this.appointmentTypeId || this.appointmentType;
    }

    get hasPresetCategory() {
        return this.categoryId || this.categoryName;
    }

}

